export default "__VITE_ASSET__nmF6n$PO__"